import classNames from 'classnames';
import { getEnv } from '../../../../../../../environment';
import { MENU_LABELS, ROUTES } from '../../constants';
import { isInvertedGTB } from '../../utils';
import { NavLink } from '../NavLink/NavLink';
import * as styles from './RightMenu.module.scss';

type Props = {
  isLoginPage: boolean;
  isPublicShop: boolean;
};

export const RightMenu = ({ isLoginPage, isPublicShop }: Props) => {
  const isInvertedGTBPage = isInvertedGTB();
  const env = getEnv();
  const LOGIN_URL = env.REACT_APP_LOGIN_BASE_URL;

  const routes = [
    {
      name: MENU_LABELS.GIFT,
      url: ROUTES.GIFT,
      enabled: !isInvertedGTBPage && !isPublicShop,
    },
    {
      name: MENU_LABELS.GET_STARTED,
      url: ROUTES.GET_STARTED,
      enabled: isLoginPage,
    },
  ];

  const links = routes.filter((link) => link.enabled);

  return (
    <div
      className={classNames(styles.rightMenuContainer, {
        [styles.loginPageRightMenuContainer]: isLoginPage,
      })}
      data-testid="right-menu"
    >
      {links.map((link, idx) => (
        <NavLink key={idx} {...link} />
      ))}

      {!isLoginPage ? <NavLink name={MENU_LABELS.LOGIN} url={LOGIN_URL} isLogin enabled /> : null}
    </div>
  );
};
